/* eslint-disable no-undefined */
/* eslint-disable max-lines-per-function */
import React from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { Grid } from "@mui/material";
import MaskedInput from "react-text-mask";
import { omit } from "lodash";
import { stateAbbreviations } from "components/haven-design/state-picker";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { MaterialFormikSelectAutocomplete as SelectAutocomplete } from "components/haven-design/form/select";
import {
  PropertyBuildings_propertyBuildings as PropertyBuildingType,
  BuildingType as BuildingTypeEnum,
} from "types/gql-types";
import { toScreamingSnakeCase } from "pages/dashboard/interests/utils";
import AddressGroup from "components/common/form/address-fields";


const BIN_MASK = [
  /[A-Za-z]/,
  /[A-Za-z]/,
  "-",
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const TextMaskCustom: React.FC<any> = (props) => {
  const other = omit(props, ["inputRef"]);
  return (
    <MaskedInput
      {...other}
      mask={BIN_MASK}
      placeholderChar={"\u2000"}
    />
  );
};

const types = ["Single Family", "Multifamily", "Townhomes", "Condo", "Other"]
  .map((label) => ({ label, value: toScreamingSnakeCase(label) }));
export type BuildingType = PropertyBuildingType

const validationSchema = yup.object({
  name: yup.string().required(),
  type: yup.string()
    .oneOf(Object.values(BuildingTypeEnum))
    .required()
    .nullable(),
  address1: yup.string().required(),
  address2: yup.string().nullable(),
  city: yup.string().required(),
  state: yup.string().required().oneOf(stateAbbreviations, "Incorrect state"),
  zip: yup.string().required()
    .trim()
    .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Incorrect zip"),
  phase: yup.string().nullable(),
  bin: yup.string().test("valid-bin", (value) => {
    if (value) {
      // assuming that value coming from masked input,
      // not validating the regex itself, just length
      return value.trim().length === 11;
    }
    return true;
  }).nullable(),
});

const emptyValues = {
  name: "",
  type: null,
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  phase: "",
  bin: "",
};

type FormPropsType = {
  id: string,
  initialValues?: BuildingType,
  onSubmit: (input: BuildingType) => void,
}

const BuildingForm: React.FC<FormPropsType> =
({ id, onSubmit, initialValues = emptyValues }) => <Formik
  initialValues={initialValues as unknown as BuildingType}
  validationSchema={validationSchema}
  onSubmit={onSubmit}
>
  {(formik) => {
    const { handleSubmit } = formik;

    return (
      <Form onSubmit={handleSubmit} id={id} style={{ paddingTop: "8px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Input margin="none" label="Building Name" required name="name" />
          </Grid>
          <Grid size={{ xs: 6, md: 4 }}>
            <SelectAutocomplete
              id="type"
              margin="none"
              name="type"
              placeholder="Type *"
              title="Building Type"
              required
              fullWidth
              options={types}
            />
          </Grid>
          <Grid size={{ xs: 6, md: 4 }}>
            <Input margin="none" label="Phase" name="phase" />
          </Grid>
          <Grid size={{ xs: 6, md: 4 }}>
            <Input margin="none" label="Bin" name="bin"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{ inputComponent: TextMaskCustom }}
              placeholder="CA-20-00021"
            />
          </Grid>
          <AddressGroup />
        </Grid>
      </Form>
    );
  }}</Formik>;
export default BuildingForm;
